import { buildClassesHook } from '../../../../helpers/styles';

export const useClasses = buildClassesHook({
    noDataContainer: {
        height: '80vh',
    },
});
